import TranslationsStore from '@bg-shared/business/Translate/Translate.store';

export const t = new TranslationsStore();

export * from './interfaces';
